package org.vreo.devicehub.di

import org.koin.core.context.loadKoinModules
import org.koin.core.context.unloadKoinModules

fun loadSessionKoinModules() {
    loadKoinModules(userSessionModule)
}

fun unLoadSessionKoinModules() {
    unloadKoinModules(userSessionModule)
}